import firebase from "firebase";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDy5c6i-STdTYSxGr6PlTTLX5bE7yhoR6s",
    authDomain: "chat-system-bc502.firebaseapp.com",
    databaseURL: "https://chat-system-bc502.firebaseio.com",
    projectId: "chat-system-bc502",
    storageBucket: "chat-system-bc502.appspot.com",
    messagingSenderId: "739954151093",
    appId: "1:739954151093:web:bd4721152417b5b78bb8fc",
    measurementId: "G-FBD4G2ZGYB"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider =new firebase.auth.GoogleAuthProvider();
  
  export { auth , provider  };
  export default db;